// A string representing a unique URL pointing temporarily to a local PDF file
export type PdfLocaFilelUrl = string;

export enum ExportType {
  ONLY_RESULTS = 'only-results',
  FULL_ANSWER_AND_RESULTS = 'full-answer-and-results',
  SOCIAL_MEDIA_SCORE_CARDS = 'social-media-score-cards',
  EXCEL_CO2_ANSWERS = 'excel-co2-answers',
}

export enum ProjectType {
  FESTIVAL = 'festival',
  VENUE = 'venue',
  TOUR = 'tour',
}

export type ProjectPdfReportsQuery = {
  export_type: ExportType;
  project_type: ProjectType;
};
